import DevicesController from './DevicesController';

export default DevicesController;
